import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

import { NotFoundView } from '#admin/components/not-found-view.tsx'
import { sessionQuery } from '#admin/features/auth/queries.ts'
import { isPlatformStaff } from '#admin/features/platform/api.ts'
import { ConsoleFrame } from '#admin/features/platform/console-frame.tsx'

/**
 * `/platform/*` — the superadmin console.
 *
 * The guard is a **404, not a 403**, and deliberately: the API's own module guard answers 404
 * for a module a tenant has not bought, on the reasoning that a tenant without `exhibitor`
 * should see an API with no exhibitor in it. The same applies more strongly here — a tenant
 * operator should not learn that a platform console exists.
 *
 * It is not the enforcement. `requirePlatformScope` on the server is; this only keeps the UI
 * from offering what the server would refuse.
 */
export const Route = createFileRoute('/_authenticated/platform')({
  staticData: { crumb: 'Platform' },
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery())
    if (!isPlatformStaff(session)) throw notFound()
  },
  // Its own, so the refusal renders in the authenticated layout's outlet with the sidebar intact.
  // A thrown not-found goes to the nearest route declaring a component for it, and that route
  // renders it in place of itself — so the app layout must not be the one to catch it.
  notFoundComponent: NotFoundView,
  component: () => (
    <ConsoleFrame>
      <Outlet />
    </ConsoleFrame>
  ),
})
